var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',[_c('AppBreadcrumb',{attrs:{"title":"လျှောက်လွှာအသေးစိတ်","items":[
      { text: 'ပင်မစာမျက်နှာ', to: { name: 'companyIndex' } },
      { text: 'လျှောက်လွှာအသေးစိတ်' }
    ]}}),_c('section',{staticClass:"resume-sec"},[_c('div',{staticClass:"sec-wrap cv-sec-wrap"},[_c('ResumeDetailContent',{attrs:{"resume":_vm.resume}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }